// extracted by mini-css-extract-plugin
export default {"way":"style_way__saGrV","point":"style_point__sS0Aq","time":"style_time__pqlsq","duration":"style_duration__Ay4-b"};